module.exports = __webpack_public_path__ + "static/assets/2d3b6fa2fd60b0c81e2ffce6899b5c1f.png";